import { useEffect, useRef } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import React from 'react';

interface Props {
  storyId: string;
}

const LoadShareloWidget = ({ storyId }: Props) => {
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    const checkAndBootSharelo = () => {
      if (window && (window as any).ShareloSDK !== 'undefined') {
        (window as any).ShareloSDK.initFloatingWidget({
          storyId,
          size: 'regular',
          view: 'vertical',
          toggleType: 'circle',
          toggleSize: 'small',
          toggleView: 'vertical',
          toggleMessage: 'Hi there✋',
          togglePosition: 'right',
          toggleSideSpacing: 24,
          toggleBottomSpacing: 24,
        });
        if (intervalRef.current) {
          window.clearInterval(intervalRef.current);
        }
      }
    };

    intervalRef.current = window.setInterval(checkAndBootSharelo, 1000);
    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, [storyId]);

  return (
    <>
      <Head>
        <link href="https://story.shareloapp.com/widget.css" rel="stylesheet" />
      </Head>
      <Script
        strategy="afterInteractive"
        src="https://story.shareloapp.com/widget.js"
        type="text/javascript"
      />
    </>
  );
};

export default LoadShareloWidget;
